<ng-template cellTemplate let-dataItem="dataItem" let-columnIndex="columnIndex">
    <span (click)="$event['ignoreClickOutside'] = true">
        <wbo-custom-object-multi-select-edit-control [value]="EntityData.getField(dataItem, this.field)"
                                                     [readonly]="true" [hideOptionOpenOption]="true"
                                                     [viewFilter]="viewFilter"
                                                     (click)="setupCellActivation(columnIndex, $event)">
        </wbo-custom-object-multi-select-edit-control>
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-custom-object-multi-select-edit-control #editControl (focussed)="columnFocusHandler(columnIndex)"
                                                 [multiObjectValueType]="multiObjectValueType"
                                                 [customObjectTypeId]="customObjectTypeId"
                                                 [excludeCustomObjectTypeId]="excludeCustomObjectTypeId"
                                                 [productLineContext]="productLineContext"
                                                 [outletContext]="outletContext"
                                                 [membershipTypeContext]="membershipTypeContext"
                                                 [viewFilter]="viewFilter"
                                                 [inventoryContext]="inventoryContext"
                                                 [formControl]="formGroup.get(field)"
                                                 [attr.id]="elementId"
                                                 (valueChange)="controlValueChange($event, dataItem, formGroup)"
                                                 [placeholder]="getPlaceholder(dataItem)">
    </wbo-custom-object-multi-select-edit-control>
</ng-template>
